<template>
  <div class="overflow-hidden custome-header-search">
    <div v-if="opened" class="search-field field has-addons has-border-primary radius-md" :class="[isVisible ? 'open-search' : 'close-search']">
      
        <!-- <input v-model="search_input" class="input input-transparent has-text-primary rounded-input is-size-7" type="text"
               :placeholder="this.sitelocale == 'en' ? 'search' : 'بحث'"> -->
               <search :sitelocale="sitelocale" link=""></search>
      
    </div>
    <!-- <a rel="noreferrer" class="search-trigger" href="#" @click.prevent="handelSearch">
      <i v-if="!opened" class="fas fa-search"></i>
      <i v-else="opened" class="fas fa-times"></i>
    </a> -->
  </div>
</template>
<script>
import axios from 'axios';
  export default {
    name: "SearchHeader",
      props: {
          categories: {
              type: Array,
              default: () => []
          },
          CategoriesLabel:{
              type:String,
              required: true
          },
          sitelocale:{
              type:String,
              required: true
          }
      },
    data() {
      return {
        opened:true,
        isVisible:true,
        category_id:'all',
        search_input:''
      };
    },


    created(){

    },

    methods: {
      handelSearch(){
        if(this.opened == false){
          this.isVisible=true;
          let self = this;
          setTimeout(function() {
            self.opened = true
            setTimeout(() => {
              $('.custome-header-search').removeClass('overflow-hidden')
            }, 2000);
          }, 50);
        }
        else{
          this.isVisible=false
          $('.custome-header-search').addClass('overflow-hidden')
          let self = this;
          setTimeout(function() {
            self.opened = false
          }, 1800);
        }

      },
        submit(){
            window.location.href = `/${this.sitelocale}/search?category_id=${this.category_id}&search_input=${this.search_input}`;
        },
    },
  }
</script>
<style lang="scss">
.search-nav{
  width: 30%;
  margin: auto;
  z-index: 999;
  margin-top: -15px;
  .custome-header-search{
    overflow: initial;
    .search-field{
      width: 92%;
      margin-top: 0;
    }
  }
  .custome-algolia-search-container .custome-algolia-search-result{
    top: 2.5rem;
  }
}
.header{
  .navbar-menu{
    .navbar-start{
      max-height: 50px;
      align-self: center;
    }
  }
}
</style>
